import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { useTheme } from 'styled-components'

import Button from 'js/components/Button/Button'
import Flexer from 'js/components/Flexer/Flexer'
import { Container } from 'js/components/Grid/Grid'
import { H2 } from 'js/components/Heading'
import Section from 'js/components/Section/Section'
import Text from 'js/components/Text/Text'
import { useViewerStore } from 'js/lib/stores'

import NotFoundIcon from 'icons/not-found.svg'

import Document from '../components/Document'

const NotFound = () => {
    const { t } = useTranslation()
    const theme = useTheme()

    const { pathname, search } = useLocation()
    const next = encodeURIComponent(`${pathname}${search}`)

    const { viewer } = useViewerStore()

    const showLoginButton =
        !viewer?.loggedIn && window.__SETTINGS__.showLoginRegister

    return (
        <Section backgroundColor="white" grow>
            <Document title={t('notfound.title')} />
            <Container style={{ textAlign: 'center' }}>
                <NotFoundIcon
                    style={{
                        margin: '24px auto',
                        width: '62px',
                        height: '78px',
                        color: theme.color.primary.main,
                    }}
                />
                <H2
                    as="h1"
                    style={{
                        marginBottom: '16px',
                        color: theme.color.primary.main,
                    }}
                >
                    {t('notfound.not-available')}
                </H2>
                {t('notfound.message')}
                <Flexer mt>
                    {showLoginButton && (
                        <>
                            <Button
                                size="normal"
                                variant="secondary"
                                as={Link}
                                to="/login"
                                state={{ next }}
                            >
                                {t('action.login')}
                            </Button>
                            <Text size="small" variant="grey">
                                {t('global.or')}
                            </Text>
                        </>
                    )}
                    <Button size="normal" variant="tertiary" as={Link} to="/">
                        {t('notfound.go-to-home')}
                    </Button>
                </Flexer>
            </Container>
        </Section>
    )
}

export default NotFound
